import React from "react";
import Header from "../Header/Header";
import Main from "../Main/Main";

export default function Contact() {
  return (
    <>
      <Header></Header>

      <Main></Main>
    </>
  );
}
